import type { FaireProductEntity } from "../../entity_types/product";

export const p_wcbghqv9fy: FaireProductEntity = {
  token: "p_wcbghqv9fy",
  type: "product",
  name: "Superberry Immunity - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/886dbb4f22453a76173a08b73d3a1bfdd1f686286a665c7e54bc534f6503af94.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d9aebddbae8878c0793574f12fab421ea9553752529f62208f9c065dc0917692.png",
    "https://cdn.faire.com/fastly/f54520a432fde610fc774fb33f96c73f0476e19a31ef8149d63911f51b85c700.png"
  ],
  priceDollars: 9.8,
  description: "SUPERFOOD TEA BLEND \n\nSip to your health with this gorgeous berry blend that is packed with nature's favourite flu-fighters: elderberry, goji berries, echinacea, and ginger. The bold berry flavour makes it an addictive all-day sipper, with a hint of tingly ginger for that instant feel-good boost. Insanely delicious, hot or iced. \n\n100% ORGANIC - NUTRITIONIST FORMULATED - SUGAR FREE - CAFFEINE FREE\n\nHow to Enjoy:\n\n * Steep tea in 1 cup of 98° water for 4-6 minutes. \n * Try me with a drizzle of honey. \n * Try it iced: Steep tea double strength, sweeten and top with plenty of ice \nWhen to Steep:\n\n\n * As a part of your morning self-care ritual \n * As an afternoon treat without the sugar \n * When you feel a cold coming on \n * When you are under stress \n * When you are feeling under the weather. \nCaffeine-free\n",
  tags: [],
  msrpDollars: 15.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:45.769Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
